<h1 mat-dialog-title>{{"ACCEPT_CHALLENGE.START" | translate}}</h1>
<div mat-dialog-content>
</div>
<div class="btn-group">
  <button cdkFocusInitial (click)="accept()">{{"ACCEPT_CHALLENGE.YES" | translate}}</button>
  <button (click)="close()">{{"ACCEPT_CHALLENGE.CANCEL" | translate}}</button>
</div>
